import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'reboron/DropModal'
import { FormattedMessage } from 'react-intl'
import {
  fileDescription,
  saveFile,
  cancel,
  uploadedFile
} from '../../utils/messages'

export default class EditMentorFile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      name: props.note ? props.note.attachment_name : '',
      url: props.note ? props.note.attachment_url : '',
      description: props.note ? props.note.description : '',
      fileType: props.note ? props.note.file_type : '',
      id: props.note ? props.note.id : ''
    }

    this.handleDescriptionChangeBound = this.handleDescriptionChange.bind(this)
    this.saveNoteBound = this.saveNote.bind(this)
    this.handleCancelBound = this.handleCancel.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.note !== this.props.note) {
      this.setState({
        name: nextProps.note.attachment_name,
        url: nextProps.note.attachment_url,
        description: nextProps.note.description,
        fileType: nextProps.note.file_type,
        id: nextProps.note.id
      })
    }
  }

  render() {
    const { name, url, description, fileType } = this.state

    const modalStyle = {
      width: '880px',
      background: '#fff',
      overflow: 'scroll',
      top: '240px',
      borderRadius: '6px'
    }

    var contentStyle = {
      backgroundColor: '#fff',
      height: '100%'
    }

    return (
      <Modal
        ref="modal"
        className="edit-activity-modal"
        modalStyle={modalStyle}
        contentStyle={contentStyle}
      >
        <form id="frmMentorNote">
          <div className="qm-view">
            <h2>
              <FormattedMessage
                id={'ActivityEdit.EditMentorFile'}
                defaultMessage={'Edit a File For Mentors'}
              />
            </h2>
            {this.props.isUploadingNote ? (
              <div className="loading"></div>
            ) : (
              <div>
                <div className="form-group file">
                  <div className="title">
                    {uploadedFile}
                    <div className="requiredtool"></div>
                  </div>
                  <div>
                    <div className={`icon ${fileType}`} />
                    <div className="name">
                      <a href={url} target="_blank">
                        {name}
                      </a>
                    </div>
                  </div>
                </div>

                <div className="title">{fileDescription}</div>
                <div className="edit-fields">
                  <input
                    type="text"
                    name="description"
                    id="description"
                    className="form-control"
                    placeholder="Write a brief description of this file (optional)"
                    onChange={this.handleDescriptionChangeBound}
                    value={description}
                  />
                </div>

                <div className="bottom">
                  <div className="placeholder"></div>
                  <div
                    className="button btn-primary save-mentor-note"
                    onClick={this.saveNoteBound}
                  >
                    {saveFile}
                  </div>
                  <div
                    className="button btn-secondary cancel-add-mentor-note"
                    onClick={this.handleCancelBound}
                  >
                    {cancel}
                  </div>
                </div>
              </div>
            )}
          </div>
        </form>
      </Modal>
    )
  }

  handleDescriptionChange(e) {
    this.setState({
      description: e.target.value
    })
  }

  handleCancel() {
    this.props.closeModal()
  }

  saveNote() {
    this.props.editMentorNote(this.state.id, this.state.description)
  }
}

EditMentorFile.propTypes = {
  closeModal: PropTypes.func,
  note: PropTypes.object,
  editMentorNote: PropTypes.func,
  isUploadingNote: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/activityedit/EditMentorFile.js